"use client"
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  Button,
  Select,
  SelectTrigger,
  SelectValue,
  SelectContent,
  SelectItem,
} from "visuais"
import {
  ArrowUp, ArrowDown, ArrowUpDown, Filter, EyeOff, ChevronDown
} from "lucide-react"
import { Column } from "@tanstack/react-table"

type Props<TData> = {
  column: Column<TData, unknown>
  table: any
  label: string
  accessorKey: keyof TData
}

export function ColunaSelectFiltro<TData>({ column, table, label, accessorKey }: Props<TData>) {
  const filterValue = column.getFilterValue() as string
  const sortDirection = column.getIsSorted()

  const uniqueValues = Array.from(
    new Set(
      table.getPreFilteredRowModel().rows.map(
        (row: any) => String(row.getValue(accessorKey))
      )
    )
  ).sort()

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" className="h-8">
          {label}
          <ChevronDown className="size-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="w-48">
        <DropdownMenuItem onClick={() => column.toggleSorting(false)} className="flex items-center gap-2">
          <ArrowUp className="h-3 w-3" />
          Ordenar Crescente
          {sortDirection === 'asc' && <span className="ml-auto text-blue-600">✓</span>}
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => column.toggleSorting(true)} className="flex items-center gap-2">
          <ArrowDown className="h-3 w-3" />
          Ordenar Decrescente
          {sortDirection === 'desc' && <span className="ml-auto text-blue-600">✓</span>}
        </DropdownMenuItem>
        {sortDirection && (
          <DropdownMenuItem onClick={() => column.clearSorting()} className="flex items-center gap-2">
            <ArrowUpDown className="h-3 w-3" />
            Remover Ordenação
          </DropdownMenuItem>
        )}
        <DropdownMenuSeparator />
        <div className="px-2 py-2">
          <div className="flex items-center gap-2 mb-2">
            <Filter className="h-3 w-3" />
            <span className="text-xs font-medium">Filtrar</span>
            {filterValue && <span className="text-blue-600 text-xs">✓</span>}
          </div>

          <Select
            value={filterValue ?? ""}
            onValueChange={(value) => column.setFilterValue(value)}
          >
            <SelectTrigger className="h-7 text-xs">
              <SelectValue placeholder={`Filtrar ${label.toLowerCase()}...`} />
            </SelectTrigger>
            <SelectContent>
              {uniqueValues.map((value) => (
                <SelectItem key={value as string} value={value as string}>
                  {value as string}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>

          {filterValue && (
            <Button
              variant="outline"
              size="sm"
              onClick={(e) => {
                e.stopPropagation()
                column.setFilterValue("")
              }}
              className="h-6 w-full text-xs mt-1"
            >
              Limpar filtro
            </Button>
          )}
        </div>
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={() => column.toggleVisibility(false)} className="flex items-center gap-2">
          <EyeOff className="h-3 w-3" />
          Ocultar Coluna
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
